import { useTranslation } from 'react-i18next';

/**
 * Readable names for the ids the API prints: steps, profiles and the facts used by a message.
 * The raw id is the fallback for anything unknown, so a new step never shows up blank.
 * The contract's ids are snake_case; the kebab spelling of the first pass is read the same way.
 */
const ALIASES: Readonly<Record<string, string>> = {
  richiedente: 'submitter',
  approvatore: 'approver',
  gestione: 'manager',
  revisore: 'auditor',
};

const snake = (id: string) => id.trim().toLowerCase().replaceAll('-', '_');

export type Labeller = {
  readonly step: (id: string | null) => string;
  readonly profile: (id: string | null) => string;
  readonly fact: (key: string) => string;
};

/** The label functions in the reader's language. */
export function useLabels(): Labeller {
  const { t } = useTranslation('communications');
  return {
    step: (id) => {
      if (id === null) return '—';
      const key = snake(id);
      return t(`labels.step.${key}`, { defaultValue: id });
    },
    profile: (id) => {
      if (id === null) return '—';
      const key = ALIASES[snake(id)] ?? snake(id);
      return t(`labels.profile.${key}`, { defaultValue: id });
    },
    fact: (key) => t(`labels.fact.${key}`, { defaultValue: key }),
  };
}
